export const jours = [
  "lundi",
  "mardi",
  "mercredi",
  "jeudi",
  "vendredi",
  "samedi",
  "dimanche",
];

export const joursOption = [
  { value: "lundi", label: "lundi" },
  { value: "mardi", label: "mardi" },
  { value: "mercredi", label: "mercredi" },
  { value: "jeudi", label: "jeudi" },
  { value: "vendredi", label: "vendredi" },
  { value: "samedi", label: "samedi" },
  { value: "dimanche", label: "dimanche" },
];